import { attach, sample } from 'effector'
import { roadAccidentModel } from '~/entities/RoadAccident'
import { editRoadAccidentModel } from '~/features/RoadAccidents/EditRoadAccident'
import { RoadAccident } from '~/shared/api'
import { OptionEnum } from '~/shared/config/constants'
import { RoadAccidentsStatusEnum } from '~/shared/config/enums'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export type StatusFormValues = {
  status?: OptionEnum<RoadAccidentsStatusEnum> | null
}

export const statusChangeFx = attach({
  effect: roadAccidentModel.saveFx,
  source: editRoadAccidentModel.$roadAccidentId,
  mapParams: (status: StatusFormValues['status'], id) => {
    return new RoadAccident(
      {
        ...(isString(status?.id) && { status: status.id }),
      },
      id as string,
    )
  },
})

sample({
  clock: statusChangeFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.status successfully changed' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})
